import { loyaltyService, contentService } from '@/infrastructure/Factory'
import { ManageMembersDirectory } from '@/infrastructure/Configuration'
import { translate } from 'rhg-vue-common'

export default {
  async getMembers({ commit, dispatch }, { corporateId, name, page, limit, adminType }) {
    commit('fetchingMembers')

    try {
      const { members, totalMembers } = await loyaltyService.getManageMembers({
        corporateId,
        name,
        page,
        limit,
        adminType
      })
      commit('setMembers', { members, totalMembers })
    } catch (e) {
      dispatch('handleMembersError', e)
    }
    commit('fetchedMembers')
  },

  async deactivateMember(
    { state, commit, dispatch },
    { corporateId, loyaltyNumber, modalId, successModalId }
  ) {
    commit('deactivatingMember')

    try {
      await loyaltyService.deactivateMember(corporateId, loyaltyNumber)
      global.$(successModalId).modal('show')
      commit('resetMembers')
      dispatch('getMembers', {
        corporateId,
        page: state.members.page,
        name: state.filters.name,
        limit: ManageMembersDirectory.FIRST_LIMIT
      })
    } catch (e) {
      if (e?.response?.data?.type === 'problem:member-not-allowed-to-deactivate-account') {
        dispatch('handleDeactivateHybridMemberError', e)
      } else {
        dispatch('handleMembersError', e)
      }
    } finally {
      commit('deactivatedMember')
      global.$(modalId).modal('hide')
    }
  },

  setFilterByName({ commit }, name) {
    commit('setFilterByName', name)
    commit('resetMembers')
  },

  setCurrentFilteredPage({ commit }, page) {
    commit('setCurrentFilteredPage', page)
  },

  setFilterByStatus({ commit }, status) {
    commit('setFilterByStatus', status)
  },

  clearFilters({ commit }) {
    commit('clearFilters')
  },

  async generateLinks({ commit, dispatch }, { corporateId, emails, selectedProgram, r4uType }) {
    commit('generatingLinks')

    try {
      const corporateInvite = await contentService.getCorporateInvite()
      commit('setCorporateInvite', corporateInvite)

      const { links } = await loyaltyService.generateEnrollentLinks(
        corporateId,
        emails,
        selectedProgram,
        r4uType
      )
      commit('setEnrollmentLinks', links)
    } catch (e) {
      dispatch('handleMembersError', e)
    } finally {
      commit('generatedLinks')
    }
  },

  resetLinks({ commit }) {
    commit('resetLinks')
  },

  handleMembersError({ _ }, error) {
    global.ModalMsg.show('#modal-error')
  },

  handleDeactivateHybridMemberError({ _ }, error) {
    global.ModalMsg.show('#modal-error', {
      title:
        translate('peThisActionCantBeCompletedOnline') || "This action can't be completed online",
      subtitle: translate('peContactSupport') || 'Please contact support for assistance.'
    })
  }
}
